import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ChatDocument } from '../../../domain/documents/models/ChatDocument';
import { ChatDocumentsState, initialChatDocumentsState } from './chatDocumentsState';

interface SetDocumentsPayload {
    sessionId: string;
    documents: ChatDocument[];
}

interface SetIsImportingPayload {
    sessionId: string;
    count: number;
}

interface SetSelectedDocumentsPayload {
    sessionId: string;
    documentIds: string[];
}

const chatDocumentsSlice = createSlice({
    name: 'chatDocuments',
    initialState: initialChatDocumentsState,
    reducers: {
        setDocuments: (state: ChatDocumentsState, action: PayloadAction<SetDocumentsPayload>) => {
            state.bySessionId[action.payload.sessionId] = action.payload.documents;
        },
        setDocumentsBySessionId: (state: ChatDocumentsState, action: PayloadAction<Record<string, ChatDocument[]>>) => {
            state.bySessionId = action.payload;
        },
        clearDocuments: (state: ChatDocumentsState) => {
            state.bySessionId = {};
            state.isImporting = {};
            state.selectedDocumentIds = {};
        },
        setIsImporting: (state: ChatDocumentsState, action: PayloadAction<SetIsImportingPayload>) => {
            state.isImporting[action.payload.sessionId] = action.payload.count;
        },
        setSelectedDocuments: (state: ChatDocumentsState, action: PayloadAction<SetSelectedDocumentsPayload>) => {
            state.selectedDocumentIds[action.payload.sessionId] = action.payload.documentIds;
        },
        clearSelectedDocuments: (state: ChatDocumentsState, action: PayloadAction<string>) => {
            delete state.selectedDocumentIds[action.payload];
        },
    },
});

export const {
    setDocuments,
    setDocumentsBySessionId,
    clearDocuments,
    setIsImporting,
    setSelectedDocuments,
    clearSelectedDocuments,
} = chatDocumentsSlice.actions;

export default chatDocumentsSlice.reducer;
